module.exports = __webpack_public_path__ + "static/media/drink-deals-mob.ee588fb7.jpeg";